export const RebateEventType = Object.freeze({
  R: 'Register',
  S: 'Switch Applicant',
  C: 'Change Period',
  W: 'Withdraw',
});

export default RebateEventType;
